import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import {
  updateCustomQuestions,
  updateSelectedQuestion,
} from "../../../../../store/steps/stepFourSlice";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import { STATIC_STRINGS } from "@asez/shared";
import QuestionOption from "./QuestionOption";
import CustomQuestionModal from "./CustomQuestionModal";

const QuestionSelection = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState("");
  const customQuestions = useSelector(
    (state: RootState) => state.stepFour.customQuestions
  );
  const selectedQuestions = useSelector(
    (state: RootState) => state.stepFour.selectedQuestions
  );

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    question:
      | { name: string; include: boolean }
      | { question: string; questionType: string; include: boolean }
  ) => {
    if ("question" in question) {
      dispatch(
        updateCustomQuestions({
          question: question.question,
          questionType: question.questionType,
          include: event.target.checked,
        })
      );
    } else {
      dispatch(
        updateSelectedQuestion({
          name: question.name,
          include: event.target.checked,
          index: selectedQuestions.findIndex((q) => q.name === question.name),
        })
      );
    }
  };

  return (
    <>
      <div className="font-semibold py-2">
        {STATIC_STRINGS.QUESTIONS_AT_START}
      </div>
      <div className="flex flex-wrap">
        {[...selectedQuestions, ...customQuestions].map((question) => (
          <QuestionOption
            key={question.name || question.question}
            id={question.name || question.question}
            checked={question.include}
            onChange={(e) => handleCheckboxChange(e, question)}
            label={question.name || question.question}
          />
        ))}
        <button
          onClick={() => setModalOpen("open")}
          className="btn btn-outline p-1 flex items-center justify-center text-sm h-7 w-56 m-2"
        >
          <AddCircleOutline />
          <div className="ml-1">{STATIC_STRINGS.ADD_CUSTOM_QUESTION}</div>
        </button>
      </div>
      {isModalOpen && (
        <CustomQuestionModal
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};

export default QuestionSelection;
